import * as Backbone from 'backbone';
import { Router } from './router';
import { View } from './views';
import { IRouteHandler, IView, IKeyValue } from '../interfaces';
import { ApplicationOptions, ViewOptions } from '../interfaces/options';
import { TemplateUtil } from '../template/index';
import { Localization, ILocalization, DefaultLocalization } from '../compile';
import { Util } from './util';
import { ApplicationConfig } from '../const';
import { Align } from '../enums';
import { ModalUtil } from './modal';
import * as Globalize from '@mapp/globalize';
import '../extensions/ko/ko-calendar.ts';
import '../extensions/ko/ko-element.ts';
import { DEFAULTUIELEMENTOPTIONS } from 'mappMvc/const/defaultOptions';
import * as _ from 'underscore';
import { TileOrderState } from 'mappClient/enums/core';

export abstract class MvcApplication extends View implements IRouteHandler {
	public router: Router;
	private _id: string;
	public get id(): string {
		return this._id;
	}

	abstract getLocalization(): Promise<ILocalization>;
	abstract getCldr(): Promise<any>;
	abstract getApplicationOptions(): Promise<ApplicationOptions>;

	constructor(id: string, templates: any, options: ViewOptions, globals?: IKeyValue<any>) {
		super(options);

		globals = $.extend({}, globals, {
			Util: Util,
			Align: Align,
			ModalUtil: ModalUtil,
			Localization: Localization,
			DefaultLocalization: DefaultLocalization
		});

		this.registerGlobals(globals);

		this._id = id;

		//#region routing
		this.router = new Router(this);
		window.router = this.router;
		this.BeforeRoute.subscribe(routes => this.deactivateView(routes));
		//#endregion

		ko.setTemplateEngine(TemplateUtil.getStringTemplateEngine(templates));

		//i18n direction
		this.initBodyCss(ApplicationConfig.rtlCss());
		ApplicationConfig.rtlCss.subscribe(css => {
			this.initBodyCss(css);
		});

		this.init();
	}

	public init(): Promise<any> {
		return this.beforeInit()
			.then(() => this.initLocalization())
			.then(() => this.initCldr())
			.then(() => this.getApplicationOptions())
			.then(options => this.initApplication(options));
	}

	public beforeInit(): Promise<any> {
		return Promise.resolve();
	}

	public initApplication(options: ApplicationOptions) {
		this.defaultView = options.defaultView;
		this.initViews(options.views);
		if (!(options.startAfterInit == false)) {
			this.start();
		}
	}

	public initLocalization(): Promise<ILocalization> {
		return this.getLocalization().then((localization: ILocalization) => {
			Object.assign(Localization, Util.defaults({}, DefaultLocalization, localization));

			//#region TODO: Delete! Only for language testing
			//let getString = (length: number): string => {
			//	let str: string = '';
			//	for (let i = 0; i < length; i++) {
			//		str += '#';
			//	}
			//	return str;
			//};

			//let replaceFormatString = (str: string): string => {
			//	let _str = '';
			//	let indexOfPlaceholder = str.indexOf('{');
			//	if (indexOfPlaceholder >= 0) {
			//		_str += getString(indexOfPlaceholder);
			//		_str += str.slice(indexOfPlaceholder, indexOfPlaceholder + 3);
			//		_str += replaceFormatString(str.slice(indexOfPlaceholder + 3));
			//		return _str;
			//	} else {
			//		return getString(str.length);
			//	}
			//};
			//let override = (obj: any): any => {
			//	let properties: string[] = Object.getOwnPropertyNames(obj);
			//	properties.forEach(property => {
			//		if (_.isObject(obj[property])) {
			//			override(obj[property]);
			//		} else if (_.isString(obj[property])) {
			//			if ((<string>obj[property]).indexOf('{') >= 0) {
			//				//TODO: change to #{0}
			//				obj[property] = replaceFormatString(obj[property]);
			//			} else {
			//				obj[property] = getString(obj[property].length);
			//			}
			//		} else {
			//			throw new Error('This is impossible!');
			//		}
			//	});
			//};
			//override(Localization);
			//#endregion

			ko.validation.localize(Localization.Validation);

			return localization;
		});
	}

	public initCldr(): Promise<any> {
		return this.getCldr().then((cldrData: any) => {
			//i18n
			cldrData.forEach(cldrEntry => {
				Globalize.load(cldrEntry);
			});
		});
	}

	public start() {
		Backbone.history.start();
		ko.applyBindings(this, $(this.id)[0]);
	}

	private initBodyCss(css: string) {
		$('body')
			.removeClass()
			.addClass(css);
	}

	private registerGlobals(globals: IKeyValue<any>) {
		for (let g of Object.keys(globals)) {
			if (typeof window.mapp[g] == 'object') {
				window.mapp[g] = $.extend(true, window.mapp[g], globals[g]);
			} else {
				window.mapp[g] = globals[g];
			}
		}
	}
}

declare global {
	interface Window {
		mapp: any;
	}
}
